export default __webpack_public_path__ + "img/f3f14056aee3eabdee7c55f40aca345e.png";